import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faEdit,
  faRecycle,
  faTags,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./Person.css";

function Person({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
  role,
  resetUserPassword,
}) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <Row className="person align-items-center">
      <Col lg={11} className="person-header">
        <h5
          onClick={() =>
            navigate(`/people/overview/${id}`, {
              state: { tabKey: "datosGenerales" },
            })
          }
        >
          {firstName} {lastName}
        </h5>
        <p>{language === "es" ? profileName : profileNameEnglish}</p>
      </Col>
      <Col lg={1} className="person-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={`/people/edit/${id}`}>
              <FontAwesomeIcon icon={faEdit} /> {t("Personas.Persona.Editar")}
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={`/people/edit/categories/${id}`}>
              <FontAwesomeIcon icon={faTags} />{" "}
              {t("Personas.Persona.EditarCategorias")}
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={`/people/delete/${id}`}>
              <FontAwesomeIcon icon={faTrash} />{" "}
              {t("Personas.Persona.Eliminar")}
            </Dropdown.Item>
            {role === "root" || role === "admin" ? (
              <Dropdown.Item onClick={() => resetUserPassword(id)}>
                <FontAwesomeIcon icon={faRecycle} />{" "}
                {t("Personas.Persona.Reset")}
              </Dropdown.Item>
            ) : (
              <></>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default Person;
